<nav class="nav mixed-loyalty-nav my-0">
  <a
    class="nav-item"
    [routerLink]="['/rewards/marketplace']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <label>{{ 'rewards.nav.marketplace' | translate }}</label>
  </a>
  <a
    class="nav-item"
    [routerLink]="['/rewards/events']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <label>{{ 'rewards.nav.events' | translate }}</label>
  </a>
  <a
    class="nav-item"
    [routerLink]="['/rewards/auctions']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <label>{{ 'rewards.nav.auctions' | translate }}</label>
  </a>
  <a
    class="nav-item"
    [routerLink]="['/rewards/raffles']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <label>{{ 'rewards.nav.lotto' | translate }}</label>
  </a>
  <a
    *ifScreenSize="screenType.Desktop"
    class="nav-item"
    [routerLink]="['/rewards/wallet']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <label>{{ 'rewards.nav.wallet' | translate }}</label>
  </a>
</nav>
